/* WSI magnifier (2026-10-19, Julian: "when the customer clicks on it it enlarges the picture instead of going into the
   product page"). A tap on [data-wsi-zoom] - the invisible button over a product picture on a store card or a builder
   (snippets/wsi-zoom-button.liquid) - opens a big view of that picture with the product's name. A tap anywhere, the
   Close button or Esc closes it; focus then goes back to the picture. The product name still opens the product page. */
(function () {
  if (window.__wsiZoom) return;
  window.__wsiZoom = true;
  var box = null, img = null, cap = null, closeBtn = null, from = null, was = '';

  function build() {
    box = document.createElement('div');
    box.className = 'wsi-zoombox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product picture');
    box.innerHTML = '<div class="wsi-zoombox__veil"></div><figure class="wsi-zoombox__fig"><img class="wsi-zoombox__img" alt="">' +
      '<figcaption class="wsi-zoombox__cap"></figcaption></figure>' +
      '<button type="button" class="wsi-zoombox__x" aria-label="Close the picture">&times;</button>';
    document.body.appendChild(box);
    img = box.querySelector('.wsi-zoombox__img');
    cap = box.querySelector('.wsi-zoombox__cap');
    closeBtn = box.querySelector('.wsi-zoombox__x');
    box.addEventListener('click', function (e) { e.preventDefault(); close(); });
    document.addEventListener('keydown', function (e) {
      if (!box || box.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'Tab') { e.preventDefault(); closeBtn.focus(); }   /* Close is the only stop while it is open */
    });
  }
  function focusOn(el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function open(btn) {
    if (!box) build();
    from = btn;
    var name = btn.getAttribute('data-zoom-alt') || '', big = btn.getAttribute('data-zoom-src') || '';
    /* the picture already on screen shows at once; the sharp one replaces it as soon as it has loaded */
    var shown = btn.parentElement ? btn.parentElement.querySelector('img') : null;
    var small = shown ? (shown.currentSrc || shown.src || '') : '';
    img.src = small || big;
    if (big && big !== small) {
      var pre = new Image();
      pre.onload = function () { if (!box.hidden && from === btn) img.src = big; };
      pre.src = big;
    }
    img.alt = name;
    cap.textContent = name;
    box.hidden = false;
    was = document.documentElement.style.overflow;   /* a builder's own popup may have locked the page already */
    document.documentElement.style.overflow = 'hidden';
    focusOn(closeBtn);
  }
  function close() {
    if (!box || box.hidden) return;
    box.hidden = true;
    document.documentElement.style.overflow = was;
    img.removeAttribute('src');
    if (from) focusOn(from);
  }
  /* capture phase: the tap on a picture never reaches the card's product link (Dawn stretches it over the card) */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-wsi-zoom]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    open(b);
  }, true);
})();
